import {Job, JobId, ModifyJobRequest} from '@store/@types/kpi';
import {List} from 'immutable';
import {adminApi} from 'sources/api';

export default class JobSource {
  static getJobsInAccount(): Promise<List<Job>> {
    return adminApi.getJson<Job[]>(`/jobs`).then(jobs => List(jobs));
  }
  static createJob(data: ModifyJobRequest): Promise<Job> {
    return adminApi.postJson<ModifyJobRequest, Job>(`/jobs`, data);
  }
  static updateJob(id: JobId, data: ModifyJobRequest): Promise<Job> {
    return adminApi.putJson<ModifyJobRequest, Job>(`/jobs/${id}`, data);
  }
  static deleteJob(id: JobId): Promise<void> {
    return adminApi.delete(`/jobs/${id}`);
  }
}
